import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions, FormStatusSwitch } from 'views/Components';

class ClassificacaoForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        classificacao: {
            idclassifatendimento: '',
            descclassificacao: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descclassificacao: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição da classificação obrigatória'
                },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    classificacao: this.getClassificacaoDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadClassificacao(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar a classificação de atendimento:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar a classificação de atendimento!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna a classificação padrão */
    getClassificacaoDefault = () => ({
        idclassifatendimento: '',
        descclassificacao: '',
        inativo: ANAO
    });

    /* Carrega a classificação de atendimento */
    loadClassificacao = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/classifatendimentosac/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Classificação de atendimento não encontrada!');

            history.push('/crm/classifatendimentosac');

            return;
        }

        this.safeSetState({
            classificacao: {
                idclassifatendimento: registro.idclassifatendimento || '',
                descclassificacao: registro.descclassificacao || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            classificacao: {
                ...prevState.classificacao,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de classificação de atendimento */
    getPayloadClassificacao = () => {
        const { classificacao } = this.state;

        return {
            descclassificacao: classificacao.descclassificacao || '',
            inativo: classificacao.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { classificacao, isNewRecord } = this.state;
        const { history, loadClassificacao } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadClassificacao();

            if (isNewRecord) {
                await api.post('/classifatendimentosac', payload);
            } else {
                await api.put(`/classifatendimentosac/${classificacao.idclassifatendimento}`, payload);
            }

            if (loadClassificacao) loadClassificacao();

            history.push('/crm/classifatendimentosac');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/crm/classifatendimentosac');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { classificacao, schema } = this.state;

        return validateSchemaFields(
            classificacao,
            schema,
            ['descclassificacao']
        );
    };

    render() {
        const {
            classificacao,
            errors,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Classificação de atendimento {classificacao.idclassifatendimento}
                        </Typography>

                        <FormStatusSwitch
                            checked={classificacao.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descclassificacao"
                            value={classificacao.descclassificacao || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descclassificacao || ''}
                            error={!!errors.descclassificacao}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

ClassificacaoForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadClassificacao: PropTypes.func
};

export default ClassificacaoForm;